
function generateAzureBlobPath(source, metadata, subroute){
    let folderPath = '';

    if(source?.includes('Firmware')){
        const { productId, cdVersion } = metadata;
        folderPath = `${productId}/${source}/${cdVersion}/firmware-${productId}`
    }
    if(subroute){
        const { productId, fileName } = metadata;
        if(productId) folderPath = `${productId}/${source}/${subroute}/${fileName}`;
        else folderPath = `${source}/${subroute}/${fileName}`;
    }
    else{
        const { productId, fileName } = metadata;
        if(productId) folderPath = `${productId}/${source}/${fileName}`;
        else folderPath = `${source}/${fileName}`;
    }

    return folderPath;
}

export default generateAzureBlobPath;